import { store } from "../state/store.js";

export function getLnbDescription(lnbType = store.ui.lnbType) {
  if (lnbType === "wb10410") return "Wideband - Oszillatorfrequenz: 10,41 GHz";
  if (lnbType === "wb10400") return "Wideband - Oszillatorfrequenz: 10,40 GHz";
  return "Universal - Oszillatorfrequenz: 9,75 / 10,6 GHz";
}

function toNumber(value) {
  if (value === null || value === undefined || value === "") return NaN;
  const normalized = String(value).replace(',', '.').trim();
  const num = Number(normalized);
  return Number.isFinite(num) ? num : NaN;
}

export function getBandFromFrequency(frequencyMHz) {
  const freq = toNumber(frequencyMHz);
  if (!Number.isFinite(freq)) return "";
  if (freq >= 10700 && freq < 11700) return "Low";
  if (freq >= 11700 && freq <= 12750) return "High";
  return "";
}

export function getIntermediateFrequencyMHz(frequencyMHz, lnbType = store.ui.lnbType) {
  const freq = toNumber(frequencyMHz);
  if (!Number.isFinite(freq)) return "";
  const band = getBandFromFrequency(freq);
  if (!band) return "";
  if (lnbType === "wb10410") return Math.round(freq - 10410);
  if (lnbType === "wb10400") return Math.round(freq - 10400);
  if (band === "Low") return Math.round(freq - 9750);
  if (band === "High") return Math.round(freq - 10600);
  return "";
}

export function normalizePolValue(pol) {
  const value = String(pol ?? "").trim().toLowerCase();
  if (!value) return "";
  if (value.startsWith('h') || value.includes('horz')) return 'h';
  if (value.startsWith('v') || value.includes('vert')) return 'v';
  return value;
}

export function getPolLabel(pol) {
  const normalized = normalizePolValue(pol);
  if (normalized === 'h') return 'Horz.';
  if (normalized === 'v') return 'Vert.';
  return String(pol ?? '').trim();
}

export function getPolBandLabel(pol, frequencyMHz) {
  const polLabel = getPolLabel(pol);
  const band = getBandFromFrequency(frequencyMHz);
  if (polLabel && band) return `${polLabel}/${band}`;
  return polLabel || band || "";
}
